export default __webpack_public_path__ + "static/media/step-4-de.0a12fdc3.png";